import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone,FiCalendar,FiCheckCircle,FiClock,FiMapPin,FiAward}=FiIcons;

const Hero=()=> {
const scrollToContact=()=> {
const element=document.getElementById('contact');
if (element) {
element.scrollIntoView({behavior: 'smooth'});
}
};

return (
<section className="relative min-h-screen flex items-center justify-center overflow-hidden transition-colors duration-300">
{/* Background Image with Gradient Overlay */}
<div className="absolute inset-0">
<img
src="https://api.robolly.com/templates/68eac076204cb313d7b33d14/render.jpg"
alt="Driving instruction background"
className="w-full h-full object-cover"
/>
<div className="absolute inset-0 bg-gradient-to-br from-gray-900/70 via-gray-800/60 to-gray-900/75"></div>
</div>

{/* Animated Background Pattern */}
<div className="absolute inset-0 opacity-20">
<div className="absolute inset-0" style={{
backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
}}></div>
</div>

{/* Floating Gradient Orbs */}
<div className="absolute inset-0 overflow-hidden">
<motion.div
animate={{y: [-30,30],x: [-20,20],rotate: [-10,10]}}
transition={{duration: 8,repeat: Infinity,repeatType: "reverse",ease: "easeInOut"}}
className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-gray-700/30 to-gray-600/30 rounded-full opacity-30 blur-3xl"
/>
<motion.div
animate={{y: [30,-30],x: [20,-20],rotate: [10,-10]}}
transition={{duration: 10,repeat: Infinity,repeatType: "reverse",ease: "easeInOut"}}
className="absolute bottom-20 right-10 w-40 h-40 bg-gradient-to-br from-gray-600/30 to-gray-700/30 rounded-full opacity-30 blur-3xl"
/>
<motion.div
animate={{x: [-40,40],y: [-20,20]}}
transition={{duration: 12,repeat: Infinity,repeatType: "reverse",ease: "easeInOut"}}
className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-br from-gray-700/30 to-gray-600/30 rounded-full opacity-30 blur-3xl"
/>
</div>

<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
<motion.div
initial={{opacity: 0,x: -50}}
animate={{opacity: 1,x: 0}}
transition={{duration: 0.8}}
className="text-center lg:text-left"
>
<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
Learn to Drive with{' '}
<span className="text-[#2fc468]">Confidence</span>
</h1>

<p className="text-xl text-white/95 mb-8 leading-relaxed">
From your first time behind the wheel to test day — we're here to support and guide you to success with expert instruction and personalized learning.
</p>

<div className="flex flex-col sm:flex-row gap-4 mb-12">
<motion.button
onClick={scrollToContact}
className="bg-[#2fc468] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#26a354] transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl backdrop-blur-sm"
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
>
<SafeIcon icon={FiCalendar} className="w-5 h-5" />
Book Your Lesson Today
</motion.button>
<motion.button
onClick={scrollToContact}
className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/10 transition-all duration-200 flex items-center justify-center gap-2 backdrop-blur-sm"
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
>
<SafeIcon icon={FiPhone} className="w-5 h-5" />
Call Us Now
</motion.button>
</div>

<div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
<motion.div
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.6,delay: 0.4}}
className="text-center"
>
<div className="w-16 h-16 bg-gradient-to-br from-gray-600/30 to-gray-700/30 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-2 border border-white/30 shadow-lg">
<SafeIcon icon={FiCheckCircle} className="w-8 h-8 text-gray-300" />
</div>
<div className="text-3xl font-bold text-white mb-1">High</div>
<div className="text-sm text-white/90">Pass Rate</div>
</motion.div>

<motion.div
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.6,delay: 0.5}}
className="text-center"
>
<div className="w-16 h-16 bg-gradient-to-br from-gray-600/30 to-gray-700/30 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-2 border border-white/30 shadow-lg">
<SafeIcon icon={FiClock} className="w-8 h-8 text-gray-300" />
</div>
<div className="text-3xl font-bold text-white mb-1">Flexible</div>
<div className="text-sm text-white/90">Scheduling</div>
</motion.div>

<motion.div
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.6,delay: 0.6}}
className="text-center"
>
<div className="w-16 h-16 bg-gradient-to-br from-gray-600/30 to-gray-700/30 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-2 border border-white/30 shadow-lg">
<SafeIcon icon={FiMapPin} className="w-8 h-8 text-gray-300" />
</div>
<div className="text-3xl font-bold text-white mb-1">15+</div>
<div className="text-sm text-white/90">Coverage Areas</div>
</motion.div>
</div>
</motion.div>

<motion.div
initial={{opacity: 0,x: 50}}
animate={{opacity: 1,x: 0}}
transition={{duration: 0.8,delay: 0.2}}
className="relative"
>
<motion.div
animate={{y: [-10,10]}}
transition={{duration: 4,repeat: Infinity,repeatType: "reverse",ease: "easeInOut"}}
className="relative"
>
<div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20">
<div className="space-y-4">
<div className="flex items-center gap-3 p-4 bg-gradient-to-r from-gray-600/20 to-gray-700/20 backdrop-blur-sm rounded-xl border border-white/20">
<SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-gray-300 flex-shrink-0" />
<span className="text-white font-medium">Manual & Automatic Lessons</span>
</div>
<div className="flex items-center gap-3 p-4 bg-gradient-to-r from-gray-600/20 to-gray-700/20 backdrop-blur-sm rounded-xl border border-white/20">
<SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-gray-300 flex-shrink-0" />
<span className="text-white font-medium">Intensive Courses Available</span>
</div>
<div className="flex items-center gap-3 p-4 bg-gradient-to-r from-gray-600/20 to-gray-700/20 backdrop-blur-sm rounded-xl border border-white/20">
<SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-gray-300 flex-shrink-0" />
<span className="text-white font-medium">Greater London Coverage</span>
</div>
</div>

<div className="mt-6 p-4 bg-gradient-to-r from-gray-600/20 to-gray-700/20 backdrop-blur-sm rounded-xl border border-white/20">
<div className="flex items-center gap-3 mb-2">
<div className="w-3 h-3 bg-[#2fc468] rounded-full animate-pulse"></div>
<span className="text-gray-300 font-semibold">Real Road Experience</span>
</div>
<p className="text-white/85 text-sm">Learn in actual driving conditions across London's busy streets</p>
</div>
</div>
</motion.div>
</motion.div>
</div>
</div>
</section>
);
};

export default Hero;